var map = {
	"./_0-COVER_29-07 Wash Your Hands Mouse  copy.jpeg": 798,
	"./_1-29-07 Wash Your Hands Guitar  .jpg": 4434,
	"./_10-COVER_29-07 Wash Your Hands Mouse  copy.jpg": 9720,
	"./_2-29-07 Wash Your Hands Dinner  .jpg": 5760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3425;